import axios from 'axios'

export const updateInternalFiles = async (referenceId, internalFiles) => {
  return await axios.put('/gateway/api/files/upload', {
    referenceId,
    internalFiles
  })
}
